import { apiClient } from '@/core/api/httpClient'

export default {
  loadDashboardApiCallReport: async (type) => {
    return await apiClient.get(`/api-calls/dashboard-report/${type}`)
  },
  loadDashboardApiCallChart: async (type) => {
    return await apiClient.get(`/api-calls/dashboard-chart/${type}`)
  },

  loadDashboardProductCallReport: async (type) => {
    return await apiClient.get(`/product-calls/dashboard-report/${type}`)
  },
  loadDashboardProductCallChart: async (type) => {
    return await apiClient.get(`/product-calls/dashboard-chart/${type}`)
  },
}
